/**
 * Loyalty API Client
 * Epic 68: VIP Lojalitási Program
 */

import { api } from './client';

// ============================================
// TYPES
// ============================================

export interface LoyaltyPoint {
  id: string;
  tenantId: string;
  partnerId: string;
  points: number;
  source: 'RENTAL' | 'PURCHASE' | 'SERVICE' | 'SALES' | 'BONUS' | 'REDEMPTION' | 'EXPIRY';
  sourceId?: string;
  note?: string;
  expiresAt?: string;
  createdAt: string;
}

export interface LoyaltyReward {
  id: string;
  tenantId: string;
  name: string;
  pointCost: number;
  productId?: string;
  category: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TrustedPartnerInfo {
  isTrusted: boolean;
  consecutiveCleanRentals: number;
  depositAmount: number;
}

export interface PartnerLoyaltyStatus {
  balance: number;
  history: LoyaltyPoint[];
  trusted: TrustedPartnerInfo | null;
}

export interface EarnPointsResult {
  point: LoyaltyPoint;
  newBalance: number;
}

export interface RedeemPointsResult {
  redemption: {
    id: string;
    partnerId: string;
    rewardId: string;
    pointsSpent: number;
    redeemedBy: string;
    redeemedAt: string;
  };
  pointEntry: LoyaltyPoint;
  newBalance: number;
}

// ============================================
// API CALLS
// ============================================

export async function getPartnerLoyalty(partnerId: string) {
  return api.get<{ data: PartnerLoyaltyStatus }>(`/loyalty/${partnerId}`);
}

export async function earnPoints(
  partnerId: string,
  data: {
    amount: number;
    source: 'RENTAL' | 'PURCHASE' | 'SERVICE' | 'SALES' | 'BONUS';
    // M-016: rentalCount removed — server-computed from DB rental records
    sourceId?: string;
    note?: string;
    costBearerId?: string;
  }
) {
  return api.post<{ data: EarnPointsResult | null }>(`/loyalty/${partnerId}/earn`, data);
}

export async function redeemPoints(partnerId: string, data: { rewardId: string }) {
  return api.post<{ data: RedeemPointsResult }>(`/loyalty/${partnerId}/redeem`, data);
}

export async function getLoyaltyRewards() {
  return api.get<{ data: LoyaltyReward[] }>('/loyalty/rewards');
}

export async function runYearlyReset() {
  return api.post<{ data: { resetCount: number } }>('/loyalty/yearly-reset');
}
